
import "@assets/css/common.css";
import "@assets/font/iconfont.css";
import "@assets/font/emoji-icon.css";
import "@assets/css/util.css";
import "@assets/css/alert.css";
import "@assets/css/cart_pc.css";
import "@assets/css/emoji_icon.css";
import "@assets/css/le-icon-cart.css";
import {$util, $cookie} from "@util/util.js";
import Engine from "./Engine.js";
import Constant from "@constant/index.js";
import API from "@api/index.js";
import '../vue/pc/pages/cart/index'

window._terminal = $util.isPC()?Constant.TERMINAL.PC:Constant.TERMINAL.WAP;
window._shopId = $util.getShopId();

let _engine = new Engine();
window._engine = _engine;
$(function () {
    //触发统一登录脚本,未登录的话延时500毫秒启动引擎
    if(!passport.isLogin()){
        // setTimeout(() => {
        //     _engine.start();
        // }, 1000);
        window.location.href = $util.getLoginUrl(window.location.href)

    }else{
        _engine.start();
    };

    // 页面从后台回到当前应用时刷新
    checkNowTime ();

    // 页面从后台回到当前应用时刷新
    function checkNowTime () {
        //TODO:兼容ios
        var __hidden, __state, visibilityChange;
        if (typeof document.hidden !== "undefined") {
            __hidden = "hidden";
            visibilityChange = "visibilitychange";
            __state = "visibilityState";
        } else if (typeof document.mozHidden !== "undefined") {
            __hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
            __state = "mozVisibilityState";
        } else if (typeof document.msHidden !== "undefined") {
            __hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
            __state = "msVisibilityState";
        } else if (typeof document.webkitHidden !== "undefined") {
            __hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
            __state = "webkitVisibilityState";
        }
        document.addEventListener(visibilityChange, function() {
            if(document[__hidden]){

            }else {
                API.getCart().then(x=>{
                    _engine._currentTime = x.t.timestamp;
                    const nowDate = new Date();
                    //客户本地时间与服务器时间的差值
                    _engine._timeDiff = _engine._currentTime - nowDate.getTime();
                    _engine.reRenderCart(x.t);
                    _engine._price.init(x.t);
                    _engine._price._view.render();
                })
            }
        }, false);
    }

});
